import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { Outlet } from 'react-router-dom';
import { auditLogApi } from '../../api';

export default function AppLayout() {
  // Fires once per module entry — this layout route doesn't remount when
  // navigating between pages inside the module (only the <Outlet /> content does).
  useEffect(() => {
    auditLogApi.logModuleEntry({ module: 'materialwatch' }).catch(() => {});
  }, []);

  // Sidebar is a fixed-width column on desktop but an off-canvas drawer
  // below the md breakpoint (see Sidebar.jsx) — this is the shared
  // open/close state for that drawer, toggled by TopBar's hamburger button.
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const location = useLocation();

  // Close the drawer automatically on navigation — otherwise it stays open
  // over the new page's content after tapping a nav link.
  useEffect(() => {
    setMobileSidebarOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex h-screen overflow-hidden" style={{ background: '#f1f5f9' }}>
      <Sidebar isOpen={mobileSidebarOpen} onClose={() => setMobileSidebarOpen(false)} />
      <div className="flex-1 flex flex-col min-w-0 h-screen overflow-hidden">
        <TopBar onMenuClick={() => setMobileSidebarOpen((v) => !v)} />
        <main className="flex-1 p-6 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
